import type { InputHTMLAttributes, ReactNode } from 'react';

import { IconRecurring } from './icon-recurring';
import { RadioCard } from './radio-card';
import { RadioCardGroup } from './radio-card-group';

type SetUpAutoshipOptionsProps = Readonly<{
    subscriptionType?: 'new' | 'existing';
    immediateTitle: ReactNode;
    nextOrderLabel: string;
    isImmediateDisabled: boolean;
    inputProps: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id' | 'value' | 'checked' | 'disabled'>;
}>;

export const SetUpAutoshipOptions = ({
    subscriptionType,
    immediateTitle,
    nextOrderLabel,
    isImmediateDisabled,
    inputProps,
}: SetUpAutoshipOptionsProps) => (
    <RadioCardGroup>
        <RadioCard
            value="new"
            checked={subscriptionType === 'new'}
            title={immediateTitle}
            disabled={isImmediateDisabled}
            inputProps={{ ...inputProps, disabled: isImmediateDisabled }}
        />
        <RadioCard
            value="existing"
            checked={subscriptionType === 'existing'}
            iconSlot={<IconRecurring />}
            title={nextOrderLabel}
            inputProps={inputProps}
        />
    </RadioCardGroup>
);
